import * as THREE from 'three';
import React, { useState, Suspense, useMemo, useLayoutEffect } from 'react';
// ... gli altri tuoi import (Canvas, useGLTF, ecc.)
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF, Center, ContactShadows, Environment, Resize } from '@react-three/drei';
import './App.css';

// --- DATI DEI MODELLI ---
// Qui inserisci i nomi esatti dei file che hai messo in public/models, il due e il sette sono stati eliminati ma sono nel model
const data = [
  { 
    id: 1, 
    url: '/models/persona1.glb', 
    nome: "Marco Rotoloni", 
    bio: "Esperto in ragazze stufe scappate di casa e render 3D. Ama la tecnologia." 
  },
  { 
    id: 3, 
    url: '/models/persona3.glb', 
    nome: "Luca Verdi", 
    bio: "Designer 3D e artista digitale. Crea mondi virtuali." 
  }, { 
    id: 4, 
    url: '/models/persona4.glb', 
    nome: "Marco Rossi", 
    bio: "Esperto in Intelligenza Artificiale e render 3D. Ama la tecnologia." 
  },
   { 
    id: 5, 
    url: '/models/persona5.glb', 
    nome: "Mario Rotti", 
    bio: "Esperto in violini e violiniste render 3D. Ama la tecnologia." 
  },
   { 
    id: 6, 
    url: '/models/persona6.glb', 
    nome: "Marco Rossasstro", 
    bio: "Esperto in gavettoni e render 3D. Ama la tecnologia." 
  },
];

// --- COMPONENTE MODELLO 3D ---
function Model({ url, scale }) {
  const { scene } = useGLTF(url);
  
  return (
    <Center>
      {/* Il trucco è qui: applichiamo la scala a un 'group' che avvolge il modello */}
      <group scale={scale}>
        <primitive object={scene.clone()} />
      </group>
    </Center>
  );
}

// --- COMPONENTE PRINCIPALE ---
function App() {
  const [index, setIndex] = useState(0);

  // Funzioni per scorrere
  const next = () => setIndex((index + 1) % data.length);
  const prev = () => setIndex((index - 1 + data.length) % data.length);

  return (
    <div className="app-container">
      {/* 1. Titolo */}
      <div className="header">
        <h1>Scegli il tuo consulente</h1>
      </div>

      {/* 2. Canvas 3D */}
      <div className="canvas-wrapper">
        <Canvas camera={{ position: [0, 2, 6], fov: 45 }}>
          <ambientLight intensity={0.5} />
          <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} />
          <pointLight position={[-10, -10, -10]} />
          <Environment preset="city" />

          <Suspense fallback={null}>
            {/* Visualizziamo il modello selezionato in base all'indice */}
            <Model url={data[index].url} />
            <ContactShadows position={[0, -0.01, 0]} opacity={0.4} scale={10} blur={2} far={4.5} />
          </Suspense>

          <OrbitControls enableZoom={false} enablePan={false} minPolarAngle={Math.PI / 2.5} maxPolarAngle={Math.PI / 2} />
        </Canvas>

        {/* Frecce di navigazione */}
        <button className="nav-btn prev" onClick={prev}>‹</button>
        <button className="nav-btn next" onClick={next}>›</button>
      </div>

      {/* 3. Didascalia (Biografia) */}
      <div className="bio-container">
        <h2>{data[index].nome}</h2>
        <p>{data[index].bio}</p>
        <button className="contact-btn">Contatta ora</button>
      </div>
    </div>
  );
}

export default App;